import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'
import './assets/css/global.css'
import IconSvg from './components/Icon-svg.vue'
import Common from './common/functions.js'
import Domain from './common/domain.js'
import { Message } from 'element-ui'

// 引入剪贴板功能插件
import VueClipboard from 'vue-clipboard2'
// socket连接池
import Sockets from './common/sockets.js'

Vue.use(Sockets)

Vue.use(VueClipboard)

Vue.prototype.$message = Message

Vue.component('IconSvg', IconSvg) // 注册到全局字体组件
Vue.prototype.$common = Common // 挂载到vue实例，在组件中通过this.$common调用
Vue.config.productionTip = false

Vue.prototype.$domain = Domain

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
